/**
 * Departments module constants.
 */
/**
 * AspNetRights checked by CCMS.Api.DepartmentManagement (seeded by InsertDepartmentManagementPermissions).
 * Each entity right covers GET, POST and PUT; the .Delete right covers DELETE.
 */
export const DEPARTMENT_RIGHTS = {
    Department: 'Department',
    DepartmentDelete: 'Department.Delete',
    Designation: 'Designation',
    DesignationDelete: 'Designation.Delete',
    DesignationTask: 'Designation.Task',
    DesignationTaskDelete: 'Designation.Task.Delete',
    Ministry: 'Ministry',
    MinistryDelete: 'Ministry.Delete',
    MinistryRole: 'Ministry.Role',
    MinistryRoleDelete: 'Ministry.Role.Delete',
    MinistryTeam: 'Ministry.Team',
    MinistryTeamDelete: 'Ministry.Team.Delete',
    MinistryEquipment: 'Ministry.Equipment',
    MinistryEquipmentDelete: 'Ministry.Equipment.Delete',
    MinistryActivity: 'Ministry.Activity',
    MinistryActivityDelete: 'Ministry.Activity.Delete',
    /** Member-designation assignments (GET, POST, PUT). */
    MemberDesignation: 'Member.Designation',
    MemberDesignationDelete: 'Member.Designation.Delete',
    /** Member-department views (GET only). */
    MemberDepartment: 'Member.Department',
};
/** Roles that open the Departments module. Admin passes every DepartmentManagement endpoint. */
export const DEPARTMENT_ROLES = {
    Admin: 'Admin',
    /** Module access role (menu + routes); rights decide what the user can do inside. */
    DepartmentsAccess: 'Departments Access',
};
//# sourceMappingURL=DepartmentConstants.js.map